import nationalitySlice from './lookup/nationalitySlice';
import religionSlice from './lookup/religionSlice';
import employmentTypeSlice from './lookup/employmentTypeSlice';
import jobGradeSlice from './lookup/jobGradeSlice';
import workLocationSlice from './lookup/workLocationSlice';
import designationSlice from './lookup/designationSlice';
import designationCategorySlice from './lookup/designationCategorySlice';
import { configureStore } from '@reduxjs/toolkit';
import { checkDevelopmentCurrentStatus } from '../helpers/Utils';
import entitySlice from './lookup/entitySlice';
import entityLevelSlice from './lookup/entityLevelSlice';
import userTypeSlice from './lookup/userTypeSlice';
import employeeStatusSlice from './lookup/employeeStatusSlice';
import employeeSlice from './lookup/employeeSlice';
import formControlSlice from './lookup/formControlSlice';
import employeeGroupSlice from './lookup/employeeGroupSlice';
import workFlowAssignTypeSlice from './lookup/workFlowAssignTypeSlice';
import formSlice from './lookup/formSlice';
import WorkFlowStagesSlice from './lookup/workFlowStagesSlice';
import workFlowSlice from './lookup/workFlowSlice';
import companySlice from './lookup/companySlice';
import targetEmployeesSlice from './lookup/targetEmployeesSlice';
import dashboardSpecificDaySlice from './dashboard/dashboard-specific-day-slice';
import notificationTypesSlice from './lookup/notificationTypesSlice';
import managerSlice from './lookup/managerSlice';
import subordinatesSlice from './lookup/subordinatesSlice';
import dashboardTypeSlice from './dashboard/dashboard-type-slice';
import dashboardSlice from './dashboard/dashboard-slice';
import userSlice from './auth/user-slice';
import reportTypeSlice from './lookup/ReportTypeSlice';
import reportSlice from './report/reportSlice';
import employeeReportSlice from './report/employee-report-slice';
import UsertypePrivilegeSlice from './lookup/usertypePrivilegeSlice';
import menuSlice from './lookup/menuSlice';
import workScheduleSlice from './pages/workScheduleSlice';
import scheduleCategorySlice from './lookup/scheduleCategorySlice';
import qualificationTypeSlice from './lookup/qualificationTypeSlice';
import policySlice from './lookup/policySlice';
import permissionTypeSlice from './lookup/permissionTypeSlice';
import timePeriodSlice from './lookup/timePeriodSlice';
import exceptionSlice from './lookup/exceptionSlice';
import manualEntrySlice from './pages/manualEntrySlice';
import recalculateSlice from './pages/recalculateSlice';
import permissionRequestSlice from './pages/permissionRequestSlice';
import remoteRequestSlice from './pages/remoteRequestSlice';
import leaveTypeSlice from './lookup/leaveTypeSlice';
import leaveDefinitionSlice from './lookup/leaveDefinitionSlice';
import employeeCategorySlice from './lookup/employeeCategorySlice';
import employeeLookupSlice from './lookup/employeeLookupSlice';
import exportMappingSlice from './report/export-mapping-slice';
import violationReportSlice from './report/violation-report-slice';
import breakDurationSlice from './lookup/breakDurationSlice';
import attendanceDurationSlice from './lookup/attendanceDurationSlice';
import timetableSlice from './lookup/timetableSlice';
import shiftWorkScheduleSlice from './lookup/shiftWorkScheduleSlice';
import temporaryScheduleSlice from './lookup/temporaryScheduleSlice';
import departmentSlice from "./lookup/departmentScheduleAssignmentSlice";
import employeeScheduleSlice from "./lookup/employeeScheduleAssignmentSlice";
import groupSlice from "./lookup/groupScheduleAssignmentSlice";
import notificationSlice from "./lookup/notificationSlice";
import loggedInEmployeeSlice from './employee/logged-in-employee-slice';
import { organizationApi } from './RTK/OragnizationsQuerys/organisation';
import { breakDefinitionApi } from './RTK/BreakDefinitionQuerys/breakdefinition';
import { baseApi } from './RTK/Api';
import { initLanguageCacheInvalidator } from './languageCacheInvalidator';
import requestKindMenuOptionsReducer from './RTK/OragnizationsQuerys/Slices/requestKindMenuOptionsSlice';
import { timetableApi } from './RTK/TimetableQuerys/timetable';
import { workScheduleApi } from './RTK/WorkScheduleQuerys/workschedule';
import { fileDownloadApi } from './RTK/FileDownload/fileDownload';

const store = configureStore({
  reducer: {
    nationality: nationalitySlice,
    religion: religionSlice,
    employmentType: employmentTypeSlice,
    jobGrade: jobGradeSlice,
    workLocation: workLocationSlice,
    designation: designationSlice,
    designationCategory: designationCategorySlice,
    userType: userTypeSlice,
    entity: entitySlice,
    entityLevel: entityLevelSlice,
    employeeStatus: employeeStatusSlice,
    employee: employeeSlice,
    formControl: formControlSlice,
    employeeGroup: employeeGroupSlice,
    workFlowAssignType: workFlowAssignTypeSlice,
    WorkFlowStages: WorkFlowStagesSlice,
    form: formSlice,
    workFlow: workFlowSlice,
    company: companySlice,
    targetEmployees: targetEmployeesSlice,
    dashboardDetails: dashboardSlice,
    dashboardSpecificDay: dashboardSpecificDaySlice,
    leaveDefinition: leaveDefinitionSlice,
    notificationTypes: notificationTypesSlice,
    manager: managerSlice,
    subordinates: subordinatesSlice,
    dashboardType: dashboardTypeSlice,
    user: userSlice,
    reportType: reportTypeSlice,
    report: reportSlice,
    employeeReport: employeeReportSlice,
    privilege: UsertypePrivilegeSlice,
    menu: menuSlice,
    workSchedule: workScheduleSlice,
    scheduleCategory: scheduleCategorySlice,
    qualificationType: qualificationTypeSlice,
    policy: policySlice,
    permissionType: permissionTypeSlice,
    timePeriod: timePeriodSlice,
    exception: exceptionSlice,
    manualEntry: manualEntrySlice,
    recalculate: recalculateSlice,
    permissionRequest: permissionRequestSlice,
    remoteRequest: remoteRequestSlice,
    leaveType: leaveTypeSlice,
    employeeCategory: employeeCategorySlice,
    employeeLookups: employeeLookupSlice,
    exportMapping: exportMappingSlice,
    violationReport: violationReportSlice,
    breakDuration: breakDurationSlice,
    attendanceDuration: attendanceDurationSlice,
    timetable: timetableSlice,
    temporarySchedule: temporaryScheduleSlice,
    shiftSchedule: shiftWorkScheduleSlice,
    department: departmentSlice,
    employeeSchedule: employeeScheduleSlice,
    group: groupSlice,
    notification: notificationSlice,
    loggedInEmployee: loggedInEmployeeSlice,

    // RTK Query
    [baseApi.reducerPath]: baseApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [breakDefinitionApi.reducerPath]: breakDefinitionApi.reducer,
    requestKindMenuOptions: requestKindMenuOptionsReducer,
    [timetableApi.reducerPath]: timetableApi.reducer,
    [workScheduleApi.reducerPath]: workScheduleApi.reducer,
    [fileDownloadApi.reducerPath]: fileDownloadApi.reducer,
  },
  devTools: checkDevelopmentCurrentStatus() ? true : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Disable performance-heavy middleware in development
      immutableCheck: false, // Disable ImmutableStateInvariantMiddleware (was taking 35ms)
      serializableCheck: false, // Disable SerializableStateInvariantMiddleware for better performance
    }).concat(baseApi.middleware),
});

initLanguageCacheInvalidator(store);

export default store;
